import React, { PureComponent } from 'react';
import Modal from '../../../components/Modal';
import { Form, FormGroup, SubmitButton, FormError } from '../../../components/Forms/Forms';
import { Input, Select } from '../../../components/Forms/fields/index';
import rules from '../../../components/Forms/rules';

class UsersView extends PureComponent {
  render() {
    const {
      users,
      openCreateModal,
      closeCreateModal,
      createModalActive,
      removeUser,
      formState,
      submitForm,
      onFormUpdate,
    } = this.props;

    return (
      <div className="users-page page">
        <h2>Users</h2>
        <div className="actions">
          <button className="button" type="button" onClick={openCreateModal}>Create User</button>
        </div>
        <table>
          <thead>
          <tr>
            <th>Username</th>
            <th>User Type</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody>
          {users.map((user, i) => (
            <tr key={user._id}>
              <td>{user.username}</td>
              <td>{user.type}</td>
              <td>
                <div className="action-buttons">
                  <button onClick={() => removeUser(user._id)}><i className="fi-x size-18"></i> delete</button>
                </div>
              </td>
            </tr>
          ))}
          </tbody>
        </table>

        <Modal active={createModalActive} onClose={closeCreateModal}>
          <Form state={formState} onSubmit={submitForm} onChange={onFormUpdate}>
            <FormGroup>
              <label>Username</label>
              <Input name="username" type="text" validate={[rules.required()]}/>
              <FormError/>
            </FormGroup>
            <FormGroup>
              <label>Type</label>
              <Select
                name="type"
                options={['admin', 'manager', 'trader', 'amazonPlugin']}
                defaultValue={'admin'}/>
              <FormError/>
            </FormGroup>
            <FormGroup>
              <label>Password</label>
              <Input name="password" type="password" validate={[rules.required()]}/>
              <FormError/>
            </FormGroup>
            <button type="submit" className="button">Create</button>
          </Form>
        </Modal>

      </div>
    )
  }
}

export default UsersView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Users/Users.view.js